/** Prefix used when drawer Ask AI appends structured drawer context for the model. */
export const DRAWER_CONTEXT_PREFIX = 'The user is asking about: '
